import { Action } from '@ngrx/store';
import { QuotePlaybackRiskWarning } from '../../model/ngrx/playback-risk-warnings.model';
import * as QuotePlaybackRiskWarningActions from './../actions/playback-risk-warnings.actions';

export type Actions = QuotePlaybackRiskWarningActions.Actions;

export function QuotePlaybackRiskWarningReducer(state: QuotePlaybackRiskWarning[] = [], action: QuotePlaybackRiskWarningActions.Actions) {
    switch (action.type) {
        case QuotePlaybackRiskWarningActions.ADD_QUOTE_PLAYBACK_RISK_WARNING:
            return [...state, action.payload];
        case QuotePlaybackRiskWarningActions.REMOVE_QUOTE_PLAYBACK_RISK_WARNING:
            state = [];
            return state;

        default:
            return state;
    }
}
